import {
  SET_LOYALTY,
  SET_TRANSACTIONS_EARNED,
  SET_TRANSACTIONS_REDEEMED,
  SET_ACTIVE_VOUCHERS,
  SET_USED_VOUCHERS,
  // TODO: import action types added later
} from './actions/types'

const INITIAL_STATE = {
  loyaltyPoints: {},
  transactionsEarned: [],
  transactionsRedeemed: [],
  activeVouchers: [],
  usedVouchers: [],
}

function setLoyaltyPoints(state, action) {
  const { loyaltyPoints } = action.payload

  return {
    ...state,
    loyaltyPoints: {
      ...loyaltyPoints,
      available: Math.floor(loyaltyPoints.available || 0),
    },
  }
}

function setTransactionsEarned(state, action) {
  return {
    ...state,
    transactionsEarned: action.payload.transactionsEarned,
  }
}

function setTransactionsRedeemed(state, action) {
  return {
    ...state,
    transactionsRedeemed: action.payload.transactionsRedeemed,
  }
}

function setActiveVouchers(state, action) {
  return {
    ...state,
    activeVouchers: action.payload.activeVouchers,
  }
}

function setUsedVouchers(state, action) {
  return {
    ...state,
    usedVouchers: action.payload.usedVouchers,
  }
}
// TODO: reflect state mutator functions for action types added later

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_LOYALTY:
      return setLoyaltyPoints(state, action)
    case SET_TRANSACTIONS_EARNED:
      return setTransactionsEarned(state, action)
    case SET_TRANSACTIONS_REDEEMED:
      return setTransactionsRedeemed(state, action)
    case SET_ACTIVE_VOUCHERS:
      return setActiveVouchers(state, action)
    case SET_USED_VOUCHERS:
      return setUsedVouchers(state, action)
    // TODO: add more action types if necessary
    default:
      break
  }

  return state
}

export default reducer
